import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filters from 'views/customers/configuration/securityChanges/filter'; // Importing Filters component
import Table from 'views/customers/configuration/securityChanges/table'; // Importing Table component
import SecurityForm from 'views/customers/configuration/securityChanges/securityForm'; // Importing SecurityForm component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the security changes view.
 * @extends JetView
 */
export default class securityChangesView extends JetView {
    /**
     * Configures the layout of the security changes view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Toolbar configuration
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6', // CSS classes for styling
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for pagination
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}', // Pager template
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default size for data fetching
                },
            ],
        };

        // Left panel configuration
        const left = {
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left panel
                    css: theme, // Applying the current theme
                    elements: [{ view: 'label', label: _('Contingencia') }], // Label with localized text
                },
                SecurityForm, // Including the SecurityForm component
            ],
        };

        // Returning the main layout configuration
        return {
            type: 'wide', // Layout type
            cols: [left], // Columns configuration
        };
    }
}

// FILE DOCUMENTED
